export default {
  title: 'Ayuda y preguntas frecuentes',
  buttons: {
    faqs: 'PREGUNTAS FRECUENTES',
    contact_us: 'Contáctanos',
  },
};
